import RestClient from '../RestClient/RestClient';
import BreadCrumbsApiEndpoints from './BreadCrumbsApiConstants';
import { apiHosts } from '../RestClient/FetchHelper.config';

/**
 * Function to fetch BreadCrumbs with default params to urlState.
 */
export const getBreadCrumbs = (params = { urlState: 'N-bwo3yD1nopet' }) => { //eslint-disable-line
    const url = `${BreadCrumbsApiEndpoints.BREAD_CRUMB_URL}`;
    const config = {
        url,
        apiHost: apiHosts.appHost,
        version: '/v5',
        params,
    };

    return RestClient.get(config);
};
